import React from 'react';
import AppProviders from './app/providers/AppProviders';
import AppRouter from './app/router';

// 全局样式
import './App.css';
import './assets/styles/suggestion-box-fix.css';
import './assets/styles/example-buttons-fix.css';
import './assets/styles/homepage-services-fix.css';
import './assets/styles/chat-phase-status-fix.css';

const App: React.FC = () => {
  return (
    <AppProviders>
      <div className="App">
        <AppRouter />
      </div>
    </AppProviders>
  );
};

export default App;
